import Aegis from '@tencent/aegis-web-sdk';

// 文档地址：http://aegis.oa.com/sdk/web.html

// 白名单关键词（白名单外的日志不上报，降低日志量）
const whiteList = [
  'eshop.qq.com',
  'test-eshop.qq.com',
  'spider.qq.com',
  'halospider.sparta.html5.qq.com',
  'access.pcgec.qq.com',
  'access-test.pcgec.qq.com',
  'router.pcgec.qq.com',
  'router-test.pcgec.qq.com',
];
// 日志level黑名单（日志类型logType为log时，需拦截的日志）
const logLevelBlackList = [
  Aegis.logType.PROMISE_ERROR, // promise 异常日志
];

const aegis = {
  instance: null, // aegis实例

  init() {
    if (this.instance !== null) return this.instance;

    this.instance = new Aegis({
      id: 'EPLxxcrqW7WnvXXQ8O', // 项目key
      reportApiSpeed: false, // 接口测速
      reportAssetSpeed: true, // 静态资源测速
      spa: true, // spa 页面需要开启，页面切换的时候上报pv
      env: process.env.NODE_ENV, // 项目环境，只有 production 环境的数据会参与项目得分的计算
      // whiteListUrl: '', // 白名单确认接口, 如果想要关闭白名单接口请求，可以传空字符串；否则去除该字段
      // eslint-disable-next-line no-undef
      version: BUILD_VERSION,
      api: {
        apiDetail: true, // 是否上报 api 的请求参数和返回值
        reportRequest: false, // 开启接口日志上报，需要同时开启 reportApiSpeed
      },
      pagePerformance: {
        // 页面测速，restful风格url地址聚合
        urlHandler() {
          // 橱窗管理页，页面地址聚合
          const managePageReg = /#\/manage\/\w+/;
          if (managePageReg.test(window.location.href)) {
            return location.href.replace(managePageReg, '#/manage/:mediaType');
          }

          // 选品中心页，页面地址聚合
          const selectedGoodsPageReg = /#\/selectedGoods\/\w+\/\w+/;
          if (selectedGoodsPageReg.test(window.location.href)) {
            return location.href.replace(selectedGoodsPageReg, '#/selectedGoods/:mediaType/:mediaId');
          }

          return location.href;
        },
      },
      beforeRequest(data) {
        // 日志类型为log
        if (data.logType === 'log') {
          if (logLevelBlackList.some(logLevel => String(data.logs.level) === String(logLevel))) return false;

          const findField = data?.logs?.ctx?.aegisUrl || undefined;
          // 日志不存在要查找的字段，保持上报
          if (!findField) return true;
          // 不在白名单列表的日志，直接拦截
          if (!whiteList.some(keywords => findField.includes(keywords))) return false;
        }

        // 日志类型为测速 (接口/静态资源测速)
        if (data.logType === 'speed') {
          const isInWhiteList = whiteList.some(keywords => data.logs.url.includes(keywords));
          // 拦截：内容不包含白名单关键词的请求
          if (!isInWhiteList) return false;
        }
      },
    });

    return this.instance;
  },

  /*
    示例：
    aegis.setConfig({
      uin: res.data.user_id, // 用户id
      ext1: JSON.stringify({
        uid: res.data.uid, // 中台id
        user_id: res.data.user_id, // 用户id
      }),
    });
   */
  setConfig(config) {
    if (!config) return;
    if (this.instance === null) return;

    this.instance.setConfig(config);
  },

  getInstance() {
    return this.instance;
  },

  /**
   * 自定义日志上报
   * 示例：
    {
      msg: '这是一个ajax错误日志',
      level: Aegis.logType.AJAX_ERROR,
      ext1: 'ext1',
      ext2: 'ext2',
      ext3: 'ext3',
      trace: 'trace',
    }
   */
  report(log = {}) {
    if (!log) return;
    if (this.instance === null) return;

    this.instance.report(log);
  },

  // 上报接口错误
  reportApiError(msg = '') {
    if (!msg) return;

    this.report({
      msg,
      level: Aegis.logType.RET_ERROR,
    });
  },

  // 上报接口信息
  reportApi(msg = '') {
    if (!msg) return;
    if (this.instance === null) return;

    this.instance.infoAll(msg);
  },

  // 白名单用户才上报
  reportWithWhiteList(msg = '') {
    if (!msg) return;
    if (this.instance === null) return;

    this.instance.info(msg);
  },
};

export default aegis;
